export const createComputed = (attribute) => {
  return {
    get() { return this.legalAd.addressAttributes ? this.legalAd.addressAttributes[attribute] : null; },
    set(value) { this.change(`${attribute}`, value); }
  };
};
